import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import ReactSlider from 'react-slider'; // eslint-disable-line

import styles from './Slider.module.scss';

interface SliderProps {
  value: number[];
  setValue: (values: string) => void;
  className?: string;
}

export const Slider: React.FC<SliderProps> = ({ className, value, setValue }) => {
  const [limits, setLimits] = useState<number[]>(value);

  useEffect(() => {
    setLimits(value); // update labels on value change
  }, [value]);

  return (
    <div>
      <ReactSlider
        className={clsx(styles.root, className)}
        thumbClassName={styles.thumb}
        trackClassName={styles.track}
        withTracks
        min={0}
        max={100}
        minDistance={1}
        step={1}
        value={value}
        onAfterChange={values => setValue(values?.join('|'))}
        onChange={values => setLimits(values)}
      />
      <div className={styles.risks}>
        <span className={styles.risk}>
          <div className={styles.label}>Minimal Risk:</div>
          <div className={styles.value}>0-{limits[0]}%</div>
        </span>
        <span className={styles.risk}>
          <div className={styles.label}>Limited Risk:</div>
          <div className={styles.value}>
            {limits[0]}-{limits[1]}%
          </div>
        </span>
        <span className={styles.risk}>
          <div className={styles.label}>High Risk:</div>
          <div className={styles.value}>
            {limits[1]}-{limits[2]}%
          </div>
        </span>
        <span className={styles.risk}>
          <div className={styles.label}>Unacceptable Risk:</div>
          <div className={styles.value}>{limits[2]}-100%</div>
        </span>
      </div>
    </div>
  );
};
